export default [
  {
    path: '',
    name: 'home-view',
    component: () => import('@/views/home/ParticipantHome.vue'),
    meta: {
      renderNav: true,
      requireAuth: true,
      title: 'Home',
    },
  },
];
